/**
 * Formats a date string into a specified format.
 * @param {string} dateString - The date string to format (e.g., '2024-07-26T00:00:00').
 * @param {string} [formatString] - The desired format string (e.g., 'dd/MM/yyyy').
 * @returns {string} - The formatted date or the original value if no format is provided.
 */
const formatDate = (dateString, formatString) => {
    if (!dateString) return dateString; // Return original value if it's empty
    if (!formatString) return dateString; // Return original value if no format is provided

    const date = new Date(dateString);

    // Define the date parts
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();

    // Create a formatted date based on the format string
    let formattedDate = formatString
        .replace('dd', day)
        .replace('MM', month)
        .replace('yyyy', year);

    return formattedDate;
};

export default formatDate;

// // Example usage:
// const originalDate = '2024-07-26T00:00:00';
// const formattedDate = formatDate(originalDate, 'dd/MM/yyyy'); // Change to desired format
// console.log(formattedDate); // Output: '26/07/2024'

// const unformattedDate = formatDate(originalDate); // No format provided
// console.log(unformattedDate); // Output: '2024-07-26T00:00:00'
